module.exports = __webpack_public_path__ + "static/media/guia-flow.1273a6fd.png";